import { useContext } from "react";
import { UserContext } from "@src/App";

import { blockCommunity } from "@src/api/community/community";
import { HOSTNAME, isExternalUrl } from "@src/utils";
import { invalidateQueriesCurrentTab } from "@src/queries/utils";

import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";

import styles from "./actionModal.module.scss";

export default function ReviewActionModal(props: {
  isOpen: boolean;
  onClose: () => void;
  communityUuid: string;
  customerUuid: string | null;
}) {
  const { isOpen, onClose, communityUuid, customerUuid } = props;

  const user = useContext(UserContext);

  function goToReviewReportPage() {
    window.location.href = isExternalUrl(`${HOSTNAME}/review/report/${communityUuid}`);
    onClose();
  }

  async function blockUser() {
    try {
      if (customerUuid === null) {
        alert("비회원은 차단이 불가능합니다. 웨딩북에 문의해주세요.");
        return;
      }

      await blockCommunity({
        myUuid: user.me.uuid,
        targetUuid: customerUuid,
      });
      alert("차단 되었습니다.");
      invalidateQueriesCurrentTab(["partner-review-list"]);
      onClose();
    } catch (error) {
      console.error("blockUser", error);
      alert("차단에 실패했습니다. 잠시 후 다시 시도해주세요.");
    }
  }

  return (
    <BottomFixedModal isShow={isOpen} hideModal={onClose} title="" isTransition={true}>
      <div className={styles["review-action-modal-content-wrap"]}>
        <MenuButton text="게시글 신고" onClick={goToReviewReportPage} />
        <MenuButton text="사용자 신고" onClick={goToReviewReportPage} />
        <MenuButton text="사용자 차단" onClick={blockUser} />
      </div>
    </BottomFixedModal>
  );
}

function MenuButton(props: { text: string; onClick: () => void }) {
  return (
    <button className={`btn ${styles["menu-button"]}`} onClick={props.onClick}>
      {props.text}
    </button>
  );
}
